<script setup lang="ts">
import { ref } from 'vue'

defineOptions({
  name: 'formBaseSearchItem',
})

const visible = ref(false)
const visible2 = ref(false)

const props = defineProps({
  itemData: {
    type: Object,
    default: {},
  },
  state1: {
    type: Object,
    default: {},
  },
  dataList: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits({
  add: (value) => value,
  group: (value) => value,
  changeCheckbox: (value) => value,
})

const methods = {
  add(item: any) {
    emit('add', item)
  },
  group(item: any) {
    emit('group', item)
  },
  hanldeCheckbox(item: any) {
    emit('changeCheckbox', item)
  },
  hanldeClickVisible2(item: any) {
    visible2.value = !visible2.value
  },
}
</script>

<template>
  <div class="form-base-search-item">
    <template v-if="!itemData.isGroup">
      <div
        class="form-base-search-item-top"
        :class="{
          'form-base-search-item-top-checkbox': itemData.checkboxValue,
        }"
      >
        <el-checkbox
          class="form-base-search-item-checkbox"
          v-model="itemData.checkboxValue"
          size="small"
          @change="methods.hanldeCheckbox(itemData)"
        />

        <el-popover
          placement="bottom-start"
          :visible="visible"
          :width="300"
          trigger="click"
        >
          <div class="form-base-search-state">
            <div v-for="(item, index) in state1" :key="index">{{ item }}</div>
          </div>
          <div>
            <el-button @click="visible = false">取消</el-button>
            <el-button type="colour-10" @click="visible = false"
              >确定</el-button
            >
          </div>
          <template #reference>
            <div
              class="form-base-search-item-label1"
              :style="{ marginLeft: itemData.level * 10 + 10 + 'px' }"
              @click="visible = !visible"
            >
              {{ itemData.fieldName }}
            </div>
          </template>
        </el-popover>

        <el-popover
          placement="bottom-start"
          :visible="visible2"
          :width="300"
          trigger="click"
        >
          <div class="form-base-search-state">
            <div v-for="(item, index) in state1" :key="index">{{ item }}</div>
          </div>
          <div>
            <el-button @click="visible2 = false">取消</el-button>
            <el-button type="colour-10" @click="visible2 = false"
              >确定</el-button
            >
          </div>
          <template #reference>
            <div
              class="form-base-search-item-label2"
              @click="methods.hanldeClickVisible2(itemData)"
            >
              包含
            </div>
          </template>
        </el-popover>

        <div class="form-base-search-item-label3"><span>&lt;?&gt;</span></div>
        <div class="form-base-search-item-btn" @click="methods.add(itemData)">
          +
        </div>
        <div class="form-base-search-item-btn" @click="methods.group(itemData)">
          <span>()</span>
          <span>+</span>
        </div>
      </div>
    </template>
    <template v-if="itemData.isGroup">
      <div
        class="form-base-search-item-top"
        :class="{
          'form-base-search-item-top-checkbox': itemData.checkboxValue,
        }"
      >
        <el-checkbox
          class="form-base-search-item-checkbox"
          v-model="itemData.checkboxValue"
          size="small"
          @change="methods.hanldeCheckbox(itemData)"
        />
        <div
          class="form-base-search-item-label6"
          :style="{ marginLeft: itemData.level * 10 + 'px' }"
        >
          （
        </div>
      </div>

      <form-base-search-item
        v-for="(item2, index2) in itemData.children"
        :key="index2"
        :item-data="item2"
        :state1="props.state1"
        :dataList="props.dataList"
        @add="methods.add"
        @group="methods.group"
        @changeCheckbox="methods.hanldeCheckbox"
      ></form-base-search-item>

      <div
        class="form-base-search-item-top"
        :class="{
          'form-base-search-item-top-checkbox': itemData.checkboxValue,
        }"
      >
        <div
          class="form-base-search-item-label6"
          :style="{ marginLeft: itemData.level * 10 + 14 + 'px' }"
        >
          &nbsp;&nbsp;）
        </div>
        <div class="form-base-search-item-btn" @click="methods.add(itemData)">
          +
        </div>
        <div class="form-base-search-item-btn" @click="methods.group(itemData)">
          <span>()</span>
          <span>+</span>
        </div>
      </div>
    </template>
  </div>
</template>
